<template>
    <div style="display: flex; flex-direction: column;">
        <LoginHeader title="미누워크"/>
        <div style="flex:1; overflow:auto; padding:20px 20px;">
            <!--<button style="font-size:20px; padding:10px;" @click="test">테스트</button>-->
            <!--<div style="display:flex; align-items: center; flex-direction: column;">-->
                <!--<div><img :src="require('@/assets/img/home_01.png')" style="width:200px;"></div>-->
                <!--<div><img :src="require('@/assets/img/home_02.png')" style="width:200px;"></div>-->
                <!--<div><img :src="require('@/assets/img/home_03.png')" style="width:200px;"></div>-->
                <!--<div><img :src="require('@/assets/img/home_04.png')" style="width:200px;"></div>-->
                <!--<div><img :src="require('@/assets/img/home_05.png')" style="width:200px;"></div>-->
            <!--</div>-->
            <!--<div style="height:20px;"></div>-->
            <div style="display:grid; grid-template-columns: 1fr 1fr; gap:20px;">
                <div><img :src="require('@/assets/img/home_new_0.jpg')" style="width:100%;" @click="showGuidePage(GUIDE_PAGE_TYPE.TRAFFIC)"></div>
                <div><img :src="require('@/assets/img/home_new_1.jpg')" style="width:100%;" @click="showGuidePage(GUIDE_PAGE_TYPE.WORK_TIME)"></div>
                <div><img :src="require('@/assets/img/home_new_2.jpg')" style="width:100%;" @click="showGuidePage(GUIDE_PAGE_TYPE.PAY)"></div>
                <div><img :src="require('@/assets/img/home_new_4.jpg')" style="width:100%;" @click="showGuidePage(GUIDE_PAGE_TYPE.NOTICE)"></div>
            </div>
        </div>
        <PageBottom />
    </div>
</template>

<script>
    import PageBottom from "../common/PageBottom";
    import LoginHeader from "../common/LoginHeader";
    import {GUIDE_PAGE_TYPE} from "./Guide";

    export default {
        name: "Home",
        components: {LoginHeader, PageBottom},
        data(){
            return {
                GUIDE_PAGE_TYPE : GUIDE_PAGE_TYPE,
            }
        },
        methods : {
            test(){
                // window.Android.showAppSetting();
                /*eslint-disable no-undef */
                // webkit.messageHandlers.ios.postMessage({cmd : 'showAppSetting'});
            },
            showGuidePage(guide_page_type){
                this.$GlobalRouter.push('/view/guide?time=' + new Date().getTime() + '&guide_page_type=' + guide_page_type);
            }
        }

    }
</script>

<style scoped>

</style>